import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { ProductAnalysisGroup4 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group4-entity';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductAnalysisGroup4Request } from 'src/app/assabil-kernel/models/dtos/control-tables/product-analysis-group4-request';


@Component({
  selector: 'app-product-analysis-group4-list',
  templateUrl: './product-analysis-group4-list.component.html',
  styleUrls: ['./product-analysis-group4-list.component.scss']
})
export class ProductAnalysisGroup4ListComponent extends BasePage2<ProductAnalysisGroup4> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  productsAnalysisGroups: ProductAnalysisGroup4[] = [];
  // ---------------------------------------------------
  

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);
                          
      this.entityName  = 'productAnalysisGroup4';
  }


  listFields = [
      { prop: 'productAnalysisGroup4Code', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang' }
  ]

  //----------------------------------------------------------------------
  getRows(): ProductAnalysisGroup4[] {
      return this.productsAnalysisGroups;
  }
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  new(){
    let entity : ProductAnalysisGroup4 = new ProductAnalysisGroup4();
    entity.inserted = true;
    entity.edit = true;
    this.productsAnalysisGroups.push(entity);
    this.productsAnalysisGroups = [...this.productsAnalysisGroups];
    }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  saveRow(productAnalysisGroup4: ProductAnalysisGroup4): Promise<ProductAnalysisGroup4> {
    let request  : ProductAnalysisGroup4Request = new ProductAnalysisGroup4Request(this.controlService.getUserInfo());
    request.productAnalysisGroup4 = productAnalysisGroup4;
      return this.controlService.save(this.entityName, request);
  }
//----------------------------------------------------------------------



//----------------------------------------------------------------------
  loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.productsAnalysisGroups = result;
        
    }); 
  }
//----------------------------------------------------------------------

  }
